import React from "react";
import { Box, keyframes, useTheme } from "@mui/material";

const sweepBlob = keyframes`
  0% { transform: translateX(-18%); opacity: 0; }
  35% { opacity: 0.85; }
  65% { opacity: 0.85; }
  100% { transform: translateX(200%); opacity: 0; }
`;

const sweepLine = keyframes`
  0% { transform: translateX(-80px); opacity: 0; }
  35% { opacity: 1; }
  65% { opacity: 1; }
  100% { transform: translateX(calc(100vw + 80px)); opacity: 0; }
`;

// نور محو آبی-نارنجی که مثل یه اسکن هوشمند از چپ به راست زیر نوبار حرکت می‌کنه
export default function NavGlow() {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 4,
          bottom: -16,
          left: 0,
          width: "42%",
          borderRadius: "50%",
          filter: "blur(24px)",
          pointerEvents: "none",
          zIndex: 0,
          background: `linear-gradient(90deg, ${theme.palette.info.main}E6, ${theme.palette.secondary.main}E6)`,
          animation: `${sweepBlob} 6s cubic-bezier(0.65, 0, 0.35, 1) infinite`,
          willChange: "transform, opacity",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: 2,
          left: 0,
          width: 120,
          height: 2,
          borderRadius: 3,
          zIndex: 3,
          pointerEvents: "none",
          background: `linear-gradient(90deg, transparent, ${theme.palette.info.main}, ${theme.palette.secondary.main}, transparent)`,
          animation: `${sweepLine} 6s cubic-bezier(0.65, 0, 0.35, 1) infinite`,
          willChange: "transform, opacity",
        }}
      />
    </>
  );
}
